<template>
  <div v-if="edms !== null">
    <!-- EDM資訊 -->
    <div class="block mb-5">
      <!-- EDM Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
          <div class="h5 ink-02-medium--text">
            顯示於EDM列表及Key Visual
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="edms.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- EDM SubTitle -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>副標題</h4>
          <div class="h5 ink-02-medium--text">
            顯示於Key Visual
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="edms.subtitle"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Tab -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Tab</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="選擇Tab"
            :isOnlyShowButtonPlaceholder="true"
            buttonWidth="160px"
            modalWidth="200px"
            :options="edmsTypeOptions"
            :selectedValue.sync="edms.tab"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- 設定日期 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-3">設定日期</h4>
          <div class="h5 ink-02-medium--text mb-3">
            前台將依設定日期顯示文章的發佈日
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="edms.published_at"
                placeholder="請選擇日期"
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="edms.published_at"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="edms.status"></FormSwitch>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於EDM列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="edms.cover_image"
            dir="edms"></ImgUploader>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Detail Page Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Detail Page <br />
            建議尺寸：1920px * 300px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="edms.visual"
            dir="edms"></ImgUploader>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="edms.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Summary -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Summary</h4>
          <div class="h5 ink-02-medium--text">顯示於內頁的前言區塊</div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-textarea
            v-model="edms.summary"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!-- Upload CSS File -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Upload CSS File</h4>
          <div class="h5 ink-02-medium--text">檔案大小限制：≤1MB, 檔案格式僅准許CSS類型</div>
        </div>
        <div class="flex-grow-1 flew-basis-0">
          <FileUploader
            v-model="edms.path"
            :dir="'edms'"
            accept="*.css"></FileUploader>
        </div>
      </div>
    </div>
    <!-- block2 seo setting -->
    <div class="block mb-5">
      <h3 class="px-5 pt-5">SEO settings</h3>
      <!-- Title -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="edms.seo_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="edms.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- EDM Slug -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="edms.slug"
            placeholder="可讀性URL"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="edms.content"
      :height="600"
      :plugins="'link image lists code'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold code|removeformat|fullscreen'"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';
import FileUploader from '@/components/CSSFileUploader.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    FormSwitch,
    ImgUploader,
    Editor,
    FileUploader,
  },
  data: () => ({
    tab: '',
    isShow: false,
    isTop: false,
    dateMenu: false,
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('edms', ['edms', 'edmsTypeOptions']),
  },
  methods: {
  },
};
</script>

<style></style>
